import styled from 'styled-components'

const PrintStyle = styled.div`
  fieldset,
  input,
  textarea,
  label,
  span,
  .date-picker {
    pointer-events: none;
  }

  textarea {
    overflow: hidden;
    line-height: 1.2;
    width: 100%;
    font-size: 16px;
    background-color: transparent;
    border: 0;
  }

  fieldset label,
  .date-picker label {
    transform: translate(0, 1.5px) scale(0.75) !important;
    transform-origin: top left !important;
  }

  main,
  .container,
  .container.rzis,
  .roznica-container,
  .list {
    height: auto;
  }

  button,
  .info-on-print,
  .hide-on-print {
    display: none;
  }

  .hide-on-print {
    display: none;
  }
`
export default PrintStyle
